import { ArrowLongLeftIcon, ArrowLongRightIcon } from '@heroicons/react/20/solid';
import { clsx } from 'clsx';
import { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSearchParams } from 'react-router';

type SearchParametersPaginationProperties = {
    total: number;
};

export const SearchParametersPagination: FunctionComponent<SearchParametersPaginationProperties> = ({ total }) => {
    const [searchParameters, setSearchParameters] = useSearchParams();
    const limit = Number.parseInt((searchParameters.get('limit') as string) || '10');
    const page = Number.parseInt((searchParameters.get('page') as string) || '1');

    return (
        <nav className={'flex items-center justify-between space-x-4 text-sm leading-6'} data-testid={'search-parameters-pagination'}>
            <div>
                <select
                    className="rounded-md border-0 py-1 pl-3 pr-6 text-sm leading-6 text-gray-600 focus:ring-0"
                    defaultValue={limit}
                    id="limit"
                    name="limit"
                    onChange={(event) => {
                        searchParameters.set('limit', event.target.value);

                        setSearchParameters(searchParameters);
                    }}
                >
                    <option value={10}>
                        10 / <FormattedMessage id={'SEARCH_PARAMETER_PAGINATION_PAGE'} />
                    </option>
                    <option value={20}>
                        20 / <FormattedMessage id={'SEARCH_PARAMETER_PAGINATION_PAGE'} />
                    </option>
                    <option value={50}>
                        50 / <FormattedMessage id={'SEARCH_PARAMETER_PAGINATION_PAGE'} />
                    </option>
                    <option value={100}>
                        100 / <FormattedMessage id={'SEARCH_PARAMETER_PAGINATION_PAGE'} />
                    </option>
                </select>
            </div>
            <div className={'text-xs uppercase text-gray-600'}>
                <FormattedMessage id={'SEARCH_PARAMETER_PAGINATION_PAGE'} /> {page}
            </div>
            <div className={'flex justify-between space-x-6'}>
                <button
                    className={clsx('inline-flex items-center border-0 text-sm font-medium text-gray-600 hover:text-gray-800', { 'opacity-20': page === 1 })}
                    disabled={page === 1}
                    onClick={() => {
                        searchParameters.set('page', `${page - 1}`);

                        setSearchParameters(searchParameters);
                    }}
                >
                    <ArrowLongLeftIcon className="mr-3 size-5 text-gray-400" /> <FormattedMessage id={'SEARCH_PARAMETER_PAGINATION_PREVIOUS'} />
                </button>
                <button
                    className={clsx('inline-flex items-center border-0 text-sm font-medium text-gray-600 hover:text-gray-800', { 'opacity-20': total < limit })}
                    disabled={total < limit}
                    onClick={() => {
                        searchParameters.set('page', `${page + 1}`);

                        setSearchParameters(searchParameters);
                    }}
                >
                    <FormattedMessage id={'SEARCH_PARAMETER_PAGINATION_NEXT'} />{' '}
                    <ArrowLongRightIcon className="ml-3 size-5 text-gray-600 hover:text-gray-800" />
                </button>
            </div>
        </nav>
    );
};
